import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsUp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 8L8 0L0 8h4v8h8V8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsUp
